import { useState } from 'react';

const ExchangeHistory = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('1M');
  
  const historicalData = [
    { date: '2024-01', rate: 17.85, change: -0.45 },
    { date: '2024-02', rate: 18.12, change: +0.27 },
    { date: '2024-03', rate: 18.45, change: +0.33 },
    { date: '2024-04', rate: 18.89, change: +0.44 },
    { date: '2024-05', rate: 18.67, change: -0.22 },
    { date: '2024-06', rate: 18.92, change: +0.25 },
    { date: '2024-07', rate: 19.15, change: +0.23 },
    { date: '2024-08', rate: 18.78, change: -0.37 },
    { date: '2024-09', rate: 19.24, change: +0.46 },
    { date: '2024-10', rate: 18.95, change: -0.29 },
    { date: '2024-11', rate: 18.73, change: -0.22 },
    { date: '2024-12', rate: 18.75, change: +0.02 },
  ];

  const periods = ['1M', '3M', '6M', '1Y'];

  return (
    <div className="mt-20">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-zinc-900 mb-4">Exchange Rate History</h2>
        <p className="text-xl text-zinc-600 max-w-2xl mx-auto">
          Track peso-dollar exchange rate trends over time to make informed currency decisions
        </p>
      </div>

      <div className="bg-white rounded-2xl p-8 border border-zinc-200 shadow-lg">
        {/* Period Selector */}
        <div className="flex justify-center mb-8">
          <div className="bg-zinc-100 rounded-full p-1">
            {periods.map((period) => (
              <button
                key={period}
                onClick={() => setSelectedPeriod(period)}
                className={`px-6 py-2 rounded-full font-semibold transition-all whitespace-nowrap ${
                  selectedPeriod === period
                    ? 'bg-emerald-500 text-white'
                    : 'text-zinc-600 hover:text-zinc-900'
                }`}
              >
                {period}
              </button>
            ))}
          </div>
        </div>

        {/* Historical Data Table */}
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-zinc-200">
                <th className="text-left py-4 px-4 font-semibold text-zinc-900">Month</th>
                <th className="text-right py-4 px-4 font-semibold text-zinc-900">Exchange Rate</th>
                <th className="text-right py-4 px-4 font-semibold text-zinc-900">Change</th>
                <th className="text-right py-4 px-4 font-semibold text-zinc-900">Trend</th>
              </tr>
            </thead>
            <tbody>
              {historicalData.slice(-6).map((data, index) => (
                <tr key={data.date} className="border-b border-zinc-100 hover:bg-zinc-50">
                  <td className="py-4 px-4 font-medium text-zinc-900">
                    {new Date(data.date + '-01').toLocaleDateString('en-US', {
                      month: 'long',
                      year: 'numeric'
                    })}
                  </td>
                  <td className="py-4 px-4 text-right font-bold text-zinc-900">
                    {data.rate.toFixed(2)} MXN
                  </td>
                  <td className={`py-4 px-4 text-right font-semibold ${
                    data.change >= 0 ? 'text-red-600' : 'text-green-600'
                  }`}>
                    {data.change >= 0 ? '+' : ''}{data.change.toFixed(2)}
                  </td>
                  <td className="py-4 px-4 text-right">
                    <div className="flex justify-end">
                      <i className={`ri-arrow-${data.change >= 0 ? 'up' : 'down'}-line text-xl ${
                        data.change >= 0 ? 'text-red-500' : 'text-green-500'
                      }`}></i>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Key Insights */}
        <div className="mt-8 grid md:grid-cols-3 gap-6">
          <div className="bg-emerald-50 rounded-xl p-6">
            <h4 className="font-bold text-emerald-800 mb-2">12-Month High</h4>
            <p className="text-2xl font-bold text-emerald-900">19.24 MXN</p>
            <p className="text-sm text-emerald-600">September 2024</p>
          </div>
          <div className="bg-blue-50 rounded-xl p-6">
            <h4 className="font-bold text-blue-800 mb-2">12-Month Low</h4>
            <p className="text-2xl font-bold text-blue-900">17.85 MXN</p>
            <p className="text-sm text-blue-600">January 2024</p>
          </div>
          <div className="bg-orange-50 rounded-xl p-6">
            <h4 className="font-bold text-orange-800 mb-2">Average Rate</h4>
            <p className="text-2xl font-bold text-orange-900">18.71 MXN</p>
            <p className="text-sm text-orange-600">12-month average</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExchangeHistory;